import React from 'react';
import { Stack, useTheme } from '@fluentui/react';
import clsx from 'clsx';
import { IAppTheme } from 'common/theme/AppTheme';
import { screenReaderOnlyStyles } from 'common/utilities/Accessibility';
import { useLocalizedStrings } from 'i18n';

import { IShimmerCardProps } from './Shimmer.Props';
import { getShimmerCardStyles } from './Shimmer.styles';

export const ShimmerCard = (props: IShimmerCardProps) => {
  const { children, height = 'auto', width = 'auto', stackProps, loadingAnnouncement, asCard = false } = props;
  const theme = useTheme() as IAppTheme;
  const styles = getShimmerCardStyles(theme);
  const { t } = useLocalizedStrings();

  return (
    <div>
      <span style={screenReaderOnlyStyles}>{loadingAnnouncement ?? t('Loading')}</span>
      <Stack className={clsx(styles.shimmerCard, asCard && styles.shimmerCardWhite)} style={{ height, width }} {...stackProps}>
        {children}
      </Stack>
    </div>
  );
};
